<template>
  <div class="px-3 alarm-level-params-tab">
    <b-row>
      <b-col cols="12">
        <span class="alarm-level-params-tab__card-name">
          {{ cardTitle }}
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="alarm-level-params-tab__table-container" cols="12">
        <s-table
          class="alarm-level-params-tab__table px-1"
          :fields="fields"
          :items="items"
          small
        >
          <template #thead-top>
            <tr class="alarm-level-params-tab__table-header-top">
              <th
                id="table-gap"
                class="alarm-level-params-tab__table-header-gap"
                colspan="2"
              >
                <span class="sr-only">Gas and sample value</span>
              </th>
              <th
                id="customization"
                class="alarm-level-params-tab__table-header-parameters"
                colspan="2">
                {{ $t('general.customization') }}
              </th>
            </tr>
          </template>
          <template #head(highLimit)="data">
            <div class="alarm-level-params-tab__display-print">
              <span
                class="
                  alarm-level-params-tab__header-subtitle
                "
                :style="{ background: getSubtitleColor('highLimit') }"
              ></span>
              <span>{{ data.label }}</span>
            </div>
          </template>
          <template #head(veryHighLimit)="data">
            <div class="alarm-level-params-tab__display-print">
              <span
                class="
                  alarm-level-params-tab__header-subtitle
                "
                :style="{ background: getSubtitleColor('veryHighLimit') }"
              ></span>
              <span >{{ data.label }}</span>
            </div>
          </template>
          <template #cell(value)="data">
            <span
              class="alarm-level-params-tab__display-print"
              :class="sampleValueClass(data.index)"
            >
              {{ numberFormatter(data.value) }}
            </span>
          </template>
          <template #cell(highLimit)="{ item }">
            <span
              class="alarm-level-params-tab__display-print">
              {{ numberFormatter(item.highLimit) }}
            </span>
          </template>
          <template #cell(veryHighLimit)="{ item }">
            <span
              class="alarm-level-params-tab__display-print">
              {{ numberFormatter(item.veryHighLimit) }}
            </span>
          </template>
        </s-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
    },
    fields: {
      type: Array,
    },
    cardTitle: {
      type: String,
    },
  },
  methods: {
    sampleValueClass(itemIndex) {
      const item = this.items[itemIndex];
      let sampleValueClass = '';
      if (item.value >= item.highLimit) {
        sampleValueClass = 'alarm-level-params-tab__high-value';
      }
      if (item.value >= item.veryHighLimit) {
        sampleValueClass = 'alarm-level-params-tab__very-high-value';
      }
      return sampleValueClass;
    },
    getSubtitleColor(field) {
      const fields = {
        veryHighLimit: 'var(--color-danger)',
        highLimit: 'var(--color-warning)',
      };
      return fields[field];
    },
    numberFormatter(value, minimumFractionDigits = 1, maximumFractionDigits = 1) {
      if (typeof value !== 'number') {
        return value;
      }
      return this.$n(value, { minimumFractionDigits, maximumFractionDigits });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .alarm-level-params-tab
    &__very-high-value
      color: $color-danger
    &__high-value
      color: $color-warning
    &__lines
      background: var(--color-background-light)
      &:nth-child(2n)
        background: var(--color-table-body-accent-bg)
    &__header
      margin: 24px 0 4px 0
    &__header-subtitle
      width: 15px
      height: 15px
      display: inline-block
      margin: 0 5px 3px 0
      vertical-align: middle
    &__item
      justify-content: center
      align-items: center
      text-align: center
      display: flex
    &__card-name
      font-size: 1.4em
      color: var(--color-primary)
      font-weight: bold
    &__table-container
      overflow: auto
    &__table
      min-width: 400px
    &__text
      color: var(--font-color-primary)
      font-size: 1em
      line-height: 1.5em
    &__table-header-gap
      background-color: var(--color-background-light) !important
    &__table-header-parameters
      border-radius: 8px 5px 0 0
      text-align: center !important
      border-left: 3px solid var(--color-background-light) !important
    ::v-deep
      thead tr:nth-child(2)
        th:last-child
          border-radius: 0 0 5px 0
        th:first-child
          border-radius: 5px 0 0 5px
      thead th:nth-child(2):not(.alarm-level-params-tab__table-header-parameters),
      .table tr td:nth-child(2)
        border-right: 3px solid var(--color-background-light) !important
        border-left: 3px solid var(--color-background-light) !important
      .table thead th:last-child, .table tbody td:last-child
        text-align: center !important
      .table tbody tr td:first-child
        min-width: 50px
    @media print
      .alarm-level-params-tab
        &__display-print
          display: block
          float: none
</style>
